import { Stack, useTheme } from "@mui/material";
import { UsersRound } from "lucide-react";
import type { FC } from "react";
import { ActivityParticipantGroup } from "web_myplann/Activities/Components/ActivityParticipantGroup";
import type { useActivityParticipantGroups } from "web_myplann/Activities/Hooks/useActivityParticipantGroups";
import {
	Resources,
	useResource,
} from "web_myplann/Infrastructure/Translations/Resources";
import { SectionHeader } from "web_myplann/Shared/Components/SectionHeader";

const R = Resources.Activity.Detail;

type Props = {
	groups: ReturnType<typeof useActivityParticipantGroups>;
};

export const ActivityParticipantsSection: FC<Props> = ({ groups }) => {
	const theme = useTheme();
	const { t } = useResource();

	if (groups.length === 0) {
		return null;
	}

	return (
		<>
			<SectionHeader
				title={t(R.Participants.title)}
				icon={<UsersRound size={14} color={theme.palette.grey[400]} />}
			/>
			<Stack bgcolor="background.paper" px={1.6} py={1.2} gap={1.2}>
				{groups.map((group) => (
					<ActivityParticipantGroup
						key={group.role}
						role={group.role}
						names={group.names}
					/>
				))}
			</Stack>
		</>
	);
};
